import { IconSvgComponent, LabelValueCardModule } from '@roomex/rx-components';

import { Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { translationProvider as Translations, TRANSLATION_SCOPE } from './assets/translation.provider';
import { TranslocoModule } from '@ngneat/transloco';
import { OutOfOfficePeriod } from '@rx-applications/clientsite/temporary-approver/utils';

@Component({
  selector: 'rx-applications-out-of-office-period',
  standalone: true,
  imports: [CommonModule, LabelValueCardModule, TranslocoModule, IconSvgComponent],
  templateUrl: './out-of-office-period.component.html',
  styleUrl: './out-of-office-period.component.scss',
  providers: [Translations],
})
export class OutOfOfficePeriodComponent {
  outOfOfficePeriod = input.required<OutOfOfficePeriod>();
  dateFormat = input.required<string>();
  regionalTimeFormat = input.required<string>();
  deleteOutOfOfficePeriod = output<OutOfOfficePeriod>();
  readonly TRANSLATION_SCOPE = TRANSLATION_SCOPE;

  deleteClicked() {
    this.deleteOutOfOfficePeriod.emit(this.outOfOfficePeriod());
  }
}
